import styled from "styled-components";

import { globalStyle, colors } from "components";

interface IProps {
  background: "primary" | "secondary";
  height: string;
}

export const Container = styled.div<IProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: calc(100% - 48px);
  height: ${(props) => (props.height ? props.height : "80px ")};
  background: ${(props) => globalStyle.headers.background[props.background]};
  padding: 0px 24px;
  gap: 12px;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
`;

export const PageLabel = styled.strong`
  margin-right: 12px;
  font-family: "Inter", "Gill Sans", "Gill Sans MT", "Trebuchet MS", sans-serif;
  color: ${colors.default_base_white};
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
export const RightSide = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;

export const BackContainer = styled.div`
  margin-right: 10px;
  cursor: pointer;
`;
